import React, { useContext, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import AppContext from '../../../Context/AppContext';
import config from '../../../config';
import { guardPortalV2Route } from '../../../util/portalV2';
import '../portalV2Shared.css';
import './NonSubscriberV2.css';

/**
 * Portal V2 non-subscriber experience — parallel to /NonSubscriber.
 * Encourages upgrade without the locked classic dashboard clutter.
 */
const NonSubscriberV2 = () => {
    const { checkUserSession } = useContext(AppContext);
    const history = useHistory();
    const session = checkUserSession() || {};

    useEffect(() => {
        guardPortalV2Route(history, '/NonSubscriber');
    }, [history]);

    const upgradeUrl =
        config.UPGRADE_URL ||
        config.UPDGRADEACCOUNTLINK ||
        config.enrollmentURL ||
        '#';

    return (
        <div className="pv2 pv2-nonsub">
            <div className="pv2-nonsub__card pv2-glass pv2-glass--strong pv2-anim">
                <p className="pv2-eyebrow">Membership</p>
                <h1 className="pv2-title">
                    Unlock your full
                    <br />
                    Oola experience
                </h1>
                <p className="pv2-sub">
                    Hi{session.firstName ? ` ${session.firstName}` : ''}. Your
                    account is active, but a subscription is needed to access
                    the Action Tracker, e-learning, and your life blueprint.
                </p>
                <ul className="pv2-nonsub__perks">
                    <li>Design My Life Blueprint (Steps 1–3)</li>
                    <li>Daily Action Tracker &amp; goals</li>
                    <li>Breakthrough, Path &amp; Additional programs</li>
                </ul>
                <a
                    className="pv2-btn pv2-btn--primary"
                    href={upgradeUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    Upgrade to continue →
                </a>
            </div>
        </div>
    );
};

export default NonSubscriberV2;
